import { bootstrapApplication } from '@angular/platform-browser';
import { isDevMode } from '@angular/core';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { Amplify } from 'aws-amplify';
import { AMPLIFY_CONFIG } from './app/core/config/amplify.config';
import { API_CONFIG } from './app/core/config/api.config';
import { environment } from './environments/environment';

// Configurar AWS Amplify solo en el navegador (no en SSR)
if (typeof window !== 'undefined') {
  const activeTheme = environment.theme || 'default';
  document.documentElement.setAttribute('data-theme', activeTheme);
  document.body.classList.remove('theme-default', 'theme-rockticket');
  document.body.classList.add(`theme-${activeTheme}`);

  if (!isDevMode() && !API_CONFIG.logEnabled) {
    // Desactivar logs en produccion (mantener warn/error)
    const noop = () => {};
    console.log = noop;
    console.debug = noop;
    console.info = noop;
  }

  console.log('🔧 Configurando Amplify antes del bootstrap...');
  console.log(`🎨 Tema activo: ${activeTheme}`);
  Amplify.configure(AMPLIFY_CONFIG, { ssr: false });
  console.log('✅ Amplify configurado correctamente');
  
  // Verificar que la configuración fue aplicada
  try {
    /* const config = Amplify.getConfig();
    console.log('📋 Configuración verificada:', {
      hasAPI: !!config.API,
      hasGraphQL: !!config.API?.GraphQL,
      endpoint: config.API?.GraphQL?.endpoint
    }); */
  } catch (error) {
    console.error('❌ Error verificando configuración:', error);
  }
}

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
